import Shuffle from 'shufflejs'
import NProgress from 'nprogress'

import lazyLoad from './lazy-load'
import scrollAnimations from './scroll-animations'

const shuffeWithLoadMore = el => {
  const shuffleContainer = el.querySelector('[data-shuffle]')
  const shuffle =
    shuffleContainer &&
    new Shuffle(shuffleContainer, {
      itemSelector: '[data-shuffle-item]',
      sizer: el.querySelector('[data-shuffle-sizer]'),
      speed: 1,
    })

  const handleLazyImages = wrapper => {
    const images = wrapper.querySelectorAll('img')
    if (shuffle) {
      images.forEach(img =>
        img.addEventListener('load', () => shuffle.update())
      )
    }
  }

  handleLazyImages(el)

  el.addEventListener('click', e => {
    const link = e.target
    if ('loadMore' in link.dataset) {
      e.preventDefault()
      NProgress.start()
      link.disabled = true
      link.className += ' pointer-none o-04'
      fetch(link.getAttribute('href'))
        .then(res => res.text())
        .then(html => {
          NProgress.done()

          const responseWrapper = document.createElement('div')
          responseWrapper.innerHTML = html

          const oldList = el.querySelector('[data-list]')
          const newItems = responseWrapper.querySelectorAll('[data-list] li')
          newItems.forEach(item => {
            oldList.appendChild(item)
            scrollAnimations(item)
            item
              .querySelectorAll('[data-lazy-image]')
              .forEach(img => lazyLoad.observer.observe(img))
            handleLazyImages(item)
          })
          if (shuffle) {
            shuffle.add(newItems)
          }

          const existingPagination = el.querySelector('[data-pagination]')
          const newPagination = responseWrapper.querySelector(
            '[data-pagination]'
          )
          existingPagination.innerHTML = newPagination.innerHTML
        })
    }
  })
}

export default shuffeWithLoadMore
